import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { getInlineLoader, setCookie } from "../Helpers";
import {
	STR_CHANGE_PHONE_NUMBER,
	STR_CHANGE_THEME,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_FITNESS,
	STR_LOGOUT,
	STR_PAYMENT_SETTINGS,
	STR_PERSONAL_SETTINGS,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdColorize, MdInfoOutline, MdLogout, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdSupport, MdSupportAgent, MdTranslate } from 'react-icons/md';
import { IoColorPaletteOutline } from "react-icons/io5";
import ComingSoon from '../views/ComingSoon';

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		await appContext.getCurrentUserData();
		setReady(true);
	}

	function logOut() {
		appContext.setShowOverlayLoader(true);
		setCookie('userId', "", -10000000);
		setCookie('userToken', "", -10000000);
		appContext.navTo({
			item: '',
		})
		appContext.refresh();
		appContext.setShowOverlayLoader(false);
	}

	useEffect(() => {
		init();
	}, [])



	return (
		<ComingSoon title={STR_FITNESS[appContext.language]}/>
	)

}